import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { qualificationEdpoints } from "@/config/endpoints";

export default function useQualification() {
  const query = useQuery({
    queryKey: ["qualification"],
    queryFn: async () => {
      const res = await axiosInstance.get(qualificationEdpoints);
      return res.data;
    },
  });
  const levelSelects = query?.data?.data?.levels?.map((val: any) => {
    return {
      value: String(val.id),
      name: val.name,
    };
  });
  const qualiSelects = query?.data?.data?.qualifications?.map((val: any) => {
    return {
      value: String(val.id),
      name: val.name,
    };
  });
  const specSelects = query?.data?.data?.specializations?.map((val: any) => {
    return {
      value: String(val.id),
      name: val.name,
    };
  });
  return {
    qualifications: query?.data?.data?.qualifications,
    levels: query?.data?.data?.levels,
    levelSelects,
    qualiSelects,
    specSelects,
    specializations: query?.data?.data?.specializations,
    result: query?.data?.result,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
